import { PostData } from '../types';
export const MultiImageFeedCrop = (data: PostData) => data.feedType === 'feed/reel' && data.hasMultipleMedia;
